<template>
  <v-navigation-drawer
    permanent
    absolute
    dark
    color="var(--primary-color)"
    style="padding-top: 60px; max-width: 300px; padding-bottom: 60px;"
  >
  <v-list nav dense expand>
    <v-list-item-group>
      <v-layout
        v-if="
          (item.roles.length === 0 && !item.excludeRoles) ||
          (item.excludeRoles
            ? item.roles.includes($store.state.Type) &&
              !item.excludeRoles.includes($store.state.Type)
            : item.roles.includes($store.state.Type))
        "
        v-for="(item, index) in menuItems"
        :key="index"
      >
        <v-list-item
          @click="$emit('close-drawer')"
          :to="'/home/' + item.to"
          v-if="item.children.length < 1"
          class="py-1"
          :class="menuItems.length - 1 !== index && 'border-white'"
          style="border-radius: 0% !important"
          link
        >
          <v-list-item-icon>
            <v-icon
              color="white"
              class="navItemIcon"
              style="font-size: 28px"
              >{{ item.icon }}</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            :class="item.classes ? item.classes.join(' ') : ''"
            style="font-size: 14px; color: #ffffff"
            >{{
              $store.state.Type === 'Admin' && item.id == 'orders'
                ? $t('navigationDrawerMenu.ordersAdmin')
                : item.title
                ? item.title
                : $t('navigationDrawerMenu.' + item.id)
            }}</v-list-item-title
          >
        </v-list-item>

        <v-list-group
          v-model="menu[item.id]"
          color="white"
          :append-icon="null"
          no-action
          v-if="item.children.length > 0"
          style="width: 100%; border-bottom: inset white !important"
        >
          <v-icon
            slot="prependIcon"
            style="font-size: 28px; color: #ffffff !important"
            >{{ item.icon }}</v-icon
          >
          <template v-slot:activator>
            <v-list-item-title
              class="ml-1"
              style="font-size: 14px; color: #ffffff !important"
              >{{
                item.title
                  ? item.title
                  : $t('navigationDrawerMenu.' + item.id)
              }}</v-list-item-title
            >
            <v-list-item-icon>
              <v-icon color="#fcd06e">{{
                menu[item.id] ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <v-layout
            v-for="(child, childIndex) in item.children"
            :key="childIndex"
          >
            <v-list-item
              v-if="
                (child.roles.length === 0 && !child.excludeRoles) ||
                (child.excludeRoles
                  ? child.roles.length > 0
                    ? child.roles.includes($store.state.Type)
                    : !child.excludeRoles.includes($store.state.Type)
                  : child.roles.includes($store.state.Type))
              "
              style="padding-left: 12%; border-radius: 0% !important"
              :class="
                item.children.length - 1 !== childIndex && 'border-white'
              "
              link
              :to="'/home/' + child.to"
              :key="childIndex"
            >
              <v-list-item-icon
                style="
                  margin-top: auto;
                  margin-bottom: auto;
                  margin-right: 10px;
                "
              >
                <v-icon style="color: #ffffff !important">{{
                  child.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title
                style="font-size: 14px; color: #ffffff !important"
                >{{
                  child.title
                    ? child.title
                    : $t('navigationDrawerMenu.' + child.id)
                }}</v-list-item-title
              >
            </v-list-item>
            <v-list-group
              no-action
              class="v-list-group__subheader"
              :value="false"
              v-if="child.children.length > 0"
              style="width: 100%; border-bottom: inset white !important"
            >
              <v-icon slot="prependIcon" style="color: #ffffff !important">{{
                child.icon
              }}</v-icon>

              <template v-slot:activator>
                <v-list-item-title
                  style="font-size: 14px; color: #ffffff !important"
                  >{{
                    child.title
                      ? child.title
                      : $t('navigationDrawerMenu.' + child.id)
                  }}</v-list-item-title
                >
              </template>
              <v-list-item
                v-for="(lastChild, lastChildIndex) in child.children"
                style="padding-left: 12%; border-radius: 0% !important"
                :class="
                  item.children.length - 1 !== childIndex && 'border-white'
                "
                :to="'/home/' + lastChild.to"
                :key="lastChildIndex"
              >
                <v-list-item-icon
                  style="
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: 10px;
                  "
                >
                  <v-icon style="color: #ffffff !important">{{
                    lastChild.icon
                  }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  style="font-size: 14px; color: #ffffff !important"
                  >{{
                    lastChild.title
                      ? lastChild.title
                      : $t('navigationDrawerMenu.' + lastChild.id)
                  }}</v-list-item-title
                >
              </v-list-item>
            </v-list-group>
          </v-layout>
        </v-list-group>
      </v-layout>
    </v-list-item-group>
  </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "NavigationDrawer",
  data() {
    return {
      menuItems: []
    };
  },
  mounted() {
    this.menuItems = [
      {
        id: 'adminList',
        icon: 'mdi-account-star-outline',
        to: 'admin-list',
        children: [],
        roles: ['SuperAdmin'],
      },
      {
        id: 'emergency',
        icon: 'mdi-alert',
        to: 'emergency',
        children: [],
        roles: ['SuperAdmin'],
      },
      {
        id: 'qrManagement',
        icon: 'mdi-qrcode-scan',
        to: 'qr-management',
        children: [],
        roles: ['SuperAdmin'],
      },
    ]
  },
  components: {},
};
</script>

<style>
.abc > .theme--light.v-icon {
  color: #cfcfcf;
}
</style>
